module.exports = __webpack_public_path__ + "static/media/instagramm.f1832221.svg";